import PropTypes from "prop-types";
import * as React from "react";
import { Typography } from "../../themeV2";
import css from "./ShopImagesEditor.module.css";

const ImageSection = React.forwardRef(function ImageSection(
  { id, title, description, actions, children },
  headingRef,
) {
  const headingId = `${id}-heading`;

  return (
    <section className={css.section} aria-labelledby={headingId}>
      <div className={css.sectionHeader}>
        <div>
          <Typography
            ref={headingRef}
            id={headingId}
            variant="title-lg"
            as="h3"
            tabIndex={-1}
            className={css.sectionHeading}
          >
            {title}
          </Typography>
          {description && (
            <Typography variant="body-md" color="variant">
              {description}
            </Typography>
          )}
        </div>
        {actions && <div className={css.sectionActions}>{actions}</div>}
      </div>
      {children}
    </section>
  );
});

ImageSection.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node,
};

export default ImageSection;
